import { render, staticRenderFns } from "./DownloadFileDialog.vue?vue&type=template&id=4008b046&scoped=true&"
import script from "./DownloadFileDialog.vue?vue&type=script&lang=js&"
export * from "./DownloadFileDialog.vue?vue&type=script&lang=js&"
import style0 from "./DownloadFileDialog.vue?vue&type=style&index=0&id=4008b046&prod&scoped=true&lang=css&"
import style1 from "./DownloadFileDialog.vue?vue&type=style&index=1&id=4008b046&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4008b046",
  null
  
)

export default component.exports